import { render, staticRenderFns } from "./AmazonFiles.vue?vue&type=template&id=1d1887e5&scoped=true&"
import script from "./AmazonFiles.vue?vue&type=script&lang=js&"
export * from "./AmazonFiles.vue?vue&type=script&lang=js&"
import style0 from "./AmazonFiles.vue?vue&type=style&index=0&id=1d1887e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1887e5",
  null
  
)

export default component.exports